import { Box, Stack, Skeleton } from '@mui/material'
import type { FC } from 'react'

import { COLORS, unit } from '@hcr/ui'

import { Path } from '../../../models'
import { to } from '../../../utils'
import { LayoutNavigationBack } from '../../common'

const BACK_NAVIGATION_PATH = to(Path.Booking)

export const BookingTimeshareIntroductionLoading: FC = () => {
  return (
    <LayoutNavigationBack to={BACK_NAVIGATION_PATH} arrowVariant='text'>
      <Box bgcolor={COLORS.white} minHeight='100vh'>
        <Stack gap={unit(4)} paddingTop={unit(24)} paddingX={unit(7)} paddingBottom={unit(4.5)}>
          <Stack gap={unit(1)}>
            <Skeleton width='80%' height={unit(14)} />
            <Skeleton width='100%' height={unit(6)} />
            <Skeleton width='100%' height={unit(6)} />
            <Skeleton width={unit(40)} height={unit(6)} />
          </Stack>

          <Stack gap={unit(1)}>
            <Skeleton width={unit(80)} height={unit(8)} />
            <Skeleton width='100%' height={unit(6)} />
            <Skeleton width='100%' height={unit(6)} />
            <Skeleton width={unit(40)} height={unit(6)} />
          </Stack>

          <Skeleton width='100%' height={unit(12)} variant='rectangular' />
        </Stack>
      </Box>
    </LayoutNavigationBack>
  )
}
